export default "__VITE_ASSET__iI0$mGfG__"